import { useState } from "react";
import { PawPrint } from "lucide-react";

const SIZES = { sm: "h-10 w-20", md: "h-12 w-20", lg: "h-16 w-28 sm:h-20 sm:w-36" };

export const ClinicLogo = ({ url, name, size = "md", testid }) => {
  const [err, setErr] = useState(false);
  const box = `${SIZES[size]} shrink-0 rounded-xl border border-[#DCE8E5] bg-white flex items-center justify-center overflow-hidden`;
  if (!url || err) {
    return <span className={`${box} bg-[#F2F7F6]`} aria-hidden="true" data-testid={testid ? `${testid}-fallback` : undefined}><PawPrint className="h-1/2 w-1/2 text-[#9DB8B4]" /></span>;
  }
  return (
    <span className={`${box} p-1`} data-testid={testid}>
      <img src={`${process.env.REACT_APP_BACKEND_URL}${url}`} alt={`${name} logo`} loading="lazy" onError={() => setErr(true)} className="max-h-full max-w-full object-contain" />
    </span>
  );
};
